jQuery(function ($) {

    // Jump to the right place in the form when uploading/deleting a photo
    $('#signup_form input[type=submit], #profile_form input[type=submit]').click(function () {
        var $button = $(this);
        var $form = $(this.form);

        var id = $button.attr('name');

        var url = $form.attr('action').replace(/#.*/, '');
        if (['upload_photo', 'delete_photo'].indexOf(id) > -1) {
            url += '#photo';
        } else if (['upload_supporter_logo', 'delete_supporter_logo'].indexOf(id) > -1) {
            url += '#corporate-details';
        }

        $form.attr('action', url);
    });
});
